// extracted by mini-css-extract-plugin
export default {"headInfo":"companyProfile_headInfo__Ml39G","container":"companyProfile_container__il0XF"};